import { ClerkProvider, SignIn, SignUp, useAuth, useUser } from '@clerk/clerk-react';

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

/**
 * Wrapper component that provides Clerk authentication
 */
export function ClerkProviderWrapper({ children }) {
    if (!PUBLISHABLE_KEY) {
        console.error('Missing VITE_CLERK_PUBLISHABLE_KEY');
        return <div>Missing Clerk Publishable Key</div>;
    }

    // Production mode - use Clerk
    // Use a stable key to prevent unnecessary re-initialization
    return (
        <ClerkProvider
            publishableKey={PUBLISHABLE_KEY}
            afterCreateOrganizationUrl="/"
            afterLeaveOrganizationUrl="/"
            appearance={{
                // Disable loading of external images to prevent CORS issues
                variables: {
                    colorPrimary: '#2563eb',
                },
            }}
        >
            {children}
        </ClerkProvider>
    );
}

/**
 * Hook to get current user info
 */
export function useCurrentUser() {
    return useUser();
}

/**
 * Hook to get auth state and token
 */
export function useAuthState() {
    return useAuth();
}

/**
 * Check if running in dev bypass mode (Always false now)
 */
export function isDevMode() {
    return false;
}

// Re-export Clerk components for convenience
export { SignIn, SignUp, useAuth };
